module.exports = __webpack_public_path__ + "static/BLB-logo-entier-23e633b02f2ecf40fd24b5addc5974ca.png";